/**
 * Created by mariushirjanu on 07/06/2019.
 */

import { HttpDataService } from '../http/http-data.service';
import { Injectable } from '@angular/core';

export interface ITranslate {
  project?:string;
  category:string;
  languageId:string;
  key:string;
  text:string;
  engText?:string;
  comments:string;
}

@Injectable()
export class TranslateDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {/**/
  }

  public getTranslation(project:string, category:string, language:string, code:string):Promise<ITranslate> {
    return this.httpDataService.doGET(
      `rest/translations/${project}/${category}/${language}/${code}`,
      {},
      undefined,
      undefined
    );
  }

  public createTranslation(translationData:ITranslate):Promise<ITranslate> {
    return this.httpDataService.doPOST(
      'rest/translations',
      undefined,
      translationData,
      undefined,
      'Error creating translation');
  }

  public updateTranslation(translationData:ITranslate):Promise<ITranslate> {
    return this.httpDataService.doPUT(
      'rest/translations',
      undefined,
      translationData,
      undefined,
      'Error updating translation'
    );
  }

  public deleteTranslation(project:string, category:string, language:string, code:string):Promise<ITranslate> {
    return this.httpDataService.doDELETE(
      `rest/translations/${project}/${category}/${language}/${code}`,
      undefined,
      'Deleting translation',
      'Error deleting translation'
    );
  }
}